import { BRAND_NAME } from './brand';

const stripHtml = (value) => {
  if (!value || typeof value !== 'string') return '';
  return value.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
};

const normalize = (value) => {
  if (!value || typeof value !== 'string') return '';
  return value
    .toLocaleLowerCase('tr-TR')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ı/g, 'i')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
};

const CATEGORY_INTROS = [
  {
    match: (key) => /^(kadin|woman|women)/.test(key) || key.includes('kadin'),
    intro: (name) =>
      `${name} koleksiyonunda günlük şıklık ile özel gün zarafeti bir arada. Yumuşak dokular ve zamansız kesimlerle ${BRAND_NAME} imzasını her kombininize taşıyın.`,
  },
  {
    match: (key) => /^(erkek|man|men)/.test(key) || key.includes('erkek'),
    intro: (name) =>
      `Sade çizgiler, konforlu kumaşlar ve her mevsime uyum sağlayan parçalar. ${name} seçkisinde ${BRAND_NAME} kalitesiyle gün boyu kendinizi iyi hissedin.`,
  },
  {
    match: (key) => key.includes('cocuk') || key.includes('kids') || key.includes('child'),
    intro: (name) =>
      `Hareket özgürlüğü sunan, dayanıklı ve sevimli parçalar. ${name} için ${BRAND_NAME} ile konfor ve neşe aynı gardıropta.`,
  },
  {
    match: (key) => key.includes('bebek') || key.includes('baby') || key.includes('newborn'),
    intro: (name) =>
      `Cildi nazik, yumuşak ve pratik parçalar. ${name} koleksiyonunda ${BRAND_NAME} özeniyle seçilmiş en özel dokunuşlar.`,
  },
  {
    match: (key) => key.includes('aksesuar') || key.includes('accessory'),
    intro: (name) =>
      `Kombinlerinize son dokunuşu katın. ${name} seçkisinde sade, şık ve her stile uyum sağlayan ${BRAND_NAME} detayları.`,
  },
  {
    match: (key) => key.includes('indirim') || key.includes('sale') || key.includes('outlet'),
    intro: (name) =>
      `Seçili parçalarda avantajlı fiyatlar. ${name} fırsatlarıyla ${BRAND_NAME} kalitesini kaçırmadan gardırobunuzu yenileyin.`,
  },
  {
    match: (key) => key.includes('yeni') || key.includes('new'),
    intro: (name) =>
      `Sezonun en taze parçaları sizi bekliyor. ${name} ile ${BRAND_NAME} koleksiyonunda yeniliği ilk siz keşfedin.`,
  },
  {
    match: (key) => key.includes('trend') || key.includes('populer') || key.includes('popular'),
    intro: (name) =>
      `En çok tercih edilen parçalar bir arada. ${name} seçkisinde ${BRAND_NAME} ile stilinize ilham verin.`,
  },
  {
    match: (key) =>
      key.includes('dis giyim') ||
      key.includes('dis-giyim') ||
      key.includes('outerwear') ||
      key.includes('mont') ||
      key.includes('ceket'),
    intro: (name) =>
      `Mevsim geçişlerine hazır, sıcak tutan ve şık parçalar. ${name} koleksiyonunda ${BRAND_NAME} ile stil ve konfor bir arada.`,
  },
  {
    match: (key) =>
      key.includes('ic giyim') ||
      key.includes('ic-giyim') ||
      key.includes('underwear') ||
      key.includes('pijama'),
    intro: (name) =>
      `Yumuşak dokulu, konfor odaklı parçalar. ${name} için ${BRAND_NAME} ile günün her anında kendinizi iyi hissedin.`,
  },
  {
    match: (key) => key.includes('ayakkabi') || key.includes('shoe'),
    intro: (name) =>
      `Günlük kullanımdan özel günlere uygun modeller. ${name} seçkisinde ${BRAND_NAME} ile adımlarınız hem rahat hem şık olsun.`,
  },
];

const buildFallbackIntro = (name, parentName) => {
  const key = normalize(`${parentName || ''} ${name}`);

  for (const rule of CATEGORY_INTROS) {
    if (rule.match(key)) {
      return rule.intro(name);
    }
  }

  return `${name} koleksiyonunda ${BRAND_NAME} imzalı parçaları keşfedin. Kaliteli kumaşlar, modern kesimler ve aile odaklı tasarımlarla stilinizi tamamlayın.`;
};

/**
 * Kategori / alt kategori sayfası için müşteri dostu intro metni.
 * API'deki description doluysa onu kullanır; yoksa marka tonuna uygun varsayılan üretir.
 */
export const getCategoryIntro = ({ category, subcategory }) => {
  const active = subcategory || category;
  const apiText = stripHtml(active?.description);

  if (apiText) {
    return { intro: apiText, source: 'api' };
  }

  const name = active?.name || 'Koleksiyon';
  const parentName = subcategory ? category?.name : null;

  return {
    intro: buildFallbackIntro(name, parentName),
    source: 'generated',
  };
};
